/** App-authored guidance only; server diagnostics never enter these messages. */
const safeErrors = {
  'Could not load activity. Please try again.':
    'No se pudo cargar la actividad. Inténtelo de nuevo.',
  'Could not open this record. Please try again.':
    'No se pudo abrir este registro. Inténtelo de nuevo.',
  'The reason needs review. Contact MedEffects for help.':
    'Es necesario revisar el motivo. Comuníquese con MedEffects para obtener ayuda.',
  'The outcome needs review. Contact MedEffects for help.':
    'Es necesario revisar el resultado. Comuníquese con MedEffects para obtener ayuda.',
  'Contact MedEffects to review this run.':
    'Comuníquese con MedEffects para revisar esta ejecución.',
  'This statement needs review. Contact MedEffects for help.':
    'Es necesario revisar este estado de cuenta. Comuníquese con MedEffects para obtener ayuda.',
  'Contact MedEffects for help with this invoice.':
    'Comuníquese con MedEffects para obtener ayuda con esta factura.',
  'Payment details need review. Contact MedEffects for help.':
    'Es necesario revisar los detalles del pago. Comuníquese con MedEffects para obtener ayuda.',
  'The file could not be created. Please try again.':
    'No se pudo crear el archivo. Inténtelo de nuevo.',
  'This payment needs review. Close this window and review the refreshed list, or contact MedEffects.':
    'Es necesario revisar este pago. Cierre esta ventana y revise la lista actualizada, o comuníquese con MedEffects.',
};

export default safeErrors;
